import siteConfig from "@iso/config/site.config";
import localStorageUtils from "@iso/lib/helpers/localStorageUtils";
import {
  getPostRequestInfo,
  getRequestGeneratorFunction
} from "@iso/utils/connectUtils";
import { createBrowserHistory } from "history";
import { put, takeEvery } from "redux-saga/effects";
import userUrls from "src/infinode/constants/urls/userUrls";
import appActions from "../app/actions";
import actions from "./actions";

const { signUp } = userUrls;

const history = createBrowserHistory();

const onSignUpRequest = ({
  username,
  password,
  email,
  phone,
  firstName,
  lastName
}) =>
  fetch(
    `${siteConfig.apiUrl}${signUp}`,
    getPostRequestInfo({
      username: username,
      password: password,
      email,
      phone,
      firstname: firstName,
      lastname: lastName
    })
  ).then(response => response.json());

const onSignUpSuccess = function* (resultBody) {
  if (resultBody.accessToken) {
    yield put({
      type: actions.INFI_SIGN_UP_SUCCESS,
      accessToken: resultBody.accessToken
    });
    return true;
  }
  return false;
};

const signUpRequest = getRequestGeneratorFunction(
  actions.INFI_SIGN_UP_REQUEST,
  actions.INFI_SIGN_UP_ERROR,
  onSignUpRequest,
  onSignUpSuccess
);

function* signUpSuccess() {
  yield takeEvery(actions.INFI_SIGN_UP_SUCCESS, function* ({
    accessToken,
    user
  }) {
    yield localStorageUtils.setLoginInfo(accessToken, user.id);
    yield appActions.clearMenu();
    yield history.push("/dashboard");
  });
}

function* signUpError() {
  yield takeEvery(actions.INFI_SIGN_UP_ERROR, function* ({ error }) {
    yield console.log(`Sign up error`);
    yield console.log(error);
  });
}

export default {
  signUpRequest,
  signUpSuccess,
  signUpError
};
